import apiClient from '@/services/rest-api-tools/apiClient'

const baseEndpoint = '/masterdata/sensor'

export const getByVehicleId = async (id, region) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/${id}`,
    headers: {
      'X-Region': region
    }
  })

  return response?.data
}

export const update = async(id, data) => {
  const response = await apiClient({
    method: "PATCH",
    url: `${baseEndpoint}/${id}`,
    data,
  })

  return response?.data
}